/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Group_What_We_BuildInputs */

const en_faq_group_what_we_build = /** @type {(inputs: Faq_Group_What_We_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we build`)
};

const lv_faq_group_what_we_build = /** @type {(inputs: Faq_Group_What_We_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko mēs veidojam`)
};

/**
* | output |
* | --- |
* | "What we build" |
*
* @param {Faq_Group_What_We_BuildInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_group_what_we_build = /** @type {((inputs?: Faq_Group_What_We_BuildInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Group_What_We_BuildInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_group_what_we_build(inputs)
	return en_faq_group_what_we_build(inputs)
});